import { AxiosResponse } from "axios";
import { AdministrarPacEdit, ArgCrearPacDTO } from "../models/administrarPac";
import axiosInstance from "../../../../interceptors/axiosInstance";

const editarPac = async (data: ArgCrearPacDTO) => {
    const response: AxiosResponse = await axiosInstance.put(
        `siscred-api-recaudacion/v1/pac/actualizar/${data.mutuoId}`, 
        data
    );
    return response;
};

const getValidar = async (idMutuo: number) => {
    const response: AxiosResponse = await axiosInstance.get(`siscred-api-recaudacion/v1/pac/validar`, {
        params: { mutuoId: idMutuo }
    });
    return response;
};

const eliminarPac = async (id: number) => {
    const response: AxiosResponse<void> = await axiosInstance.delete(
        `siscred-api-recaudacion/v1/pac/eliminar/${id}`
    );
    return response.status === 204;
};

const getCuotaPac = async (mutuoId: number) => {
    const response: AxiosResponse = await axiosInstance.get(`siscred-api-recaudacion/v1/pac/get-cuota`,{
        params: { mutuoId: mutuoId }
    })
    return response;

};

export {
    editarPac,
    getValidar,
    eliminarPac,
    getCuotaPac
}